import { adminDomainsService } from '@/services/admin-domains.service';
import type { AdminFilters } from '@/types/admin.types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useAdminDomains(filters: AdminFilters = {}) {
  return useQuery({
    queryKey: ['admin-domains', filters],
    queryFn: () => adminDomainsService.getAll(filters),
  });
}

export function useAdminDomainDetail(uuid: string | undefined) {
  return useQuery({
    queryKey: ['admin-domain', uuid],
    queryFn: () => adminDomainsService.getById(uuid!),
    enabled: !!uuid,
  });
}

export function useForceSync() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => adminDomainsService.forceSync(uuid),
    onSuccess: () => { toast.success('Synchronisation lancée'); qc.invalidateQueries({ queryKey: ['admin-domains'] }); },
    onError: () => toast.error('Erreur lors de la synchronisation'),
  });
}

export function useToggleDomainArchive() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => adminDomainsService.toggleArchive(uuid),
    onSuccess: () => { toast.success('Statut archivé mis à jour'); qc.invalidateQueries({ queryKey: ['admin-domains'] }); qc.invalidateQueries({ queryKey: ['admin-domain'] }); },
    onError: () => toast.error('Erreur lors de la mise à jour'),
  });
}
